import React, { useState, useEffect } from "react";
import { Form, Select, Input, InputNumber, Typography } from "antd";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

const ProductForm = props => {
  const [form] = Form.useForm();
  const [productKinds, setProductKinds] = useState([]);
  const [measurementUnits, setMeasurementUnits] = useState([]);
  const { t } = useTranslation();
  const isEditMode = props.isEditMode || false;

  const formItemLayout = {
    labelCol: { sm: { span: 8 } },
    wrapperCol: { sm: { span: 16 } }
  };

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/business/enums/product-kinds")
      .then(({ data }) => setProductKinds(data))
      .catch(error => console.log(error));
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/business/enums/measurement-units")
      .then(({ data }) => setMeasurementUnits(data))
      .catch(error => console.log(error));
  }, []);

  const fieldsFromAsset = asset => ({
    productKind: asset.productKind,
    productCategory: asset.productCategory,
    quantity: asset.quantity,
    unit: asset.unit,
    value: asset.value,
    details: asset.details
  });

  useEffect(() => {
    if (props.record.asset) {
      form.setFieldsValue(fieldsFromAsset(props.record.asset));
    }
  }, [props.record.asset, form]);

  useEffect(() => {
    if (!isEditMode && props.record.asset) {
      form.resetFields();
      form.setFieldsValue(fieldsFromAsset(props.record.asset));
    }
  }, [isEditMode, form, props.record.asset]);

  const handleFormChange = () => {
    if (!isEditMode) return;
    const values = form.getFieldsValue();
    const errors = form.getFieldsError();
    const isValid = errors.every(error => !error.errors.length);

    const newAsset = { ...props.record };
    newAsset.asset.productKind = elvis(values.productKind);
    newAsset.asset.productCategory = elvis(values.productCategory);
    newAsset.asset.quantity = elvis(values.quantity);
    newAsset.asset.unit = elvis(values.unit);
    newAsset.asset.value = elvis(values.value);
    newAsset.asset.details = elvis(values.details);
    newAsset.valid = isValid;
    props.parentCallback(newAsset);
  };

  return (
    <Form
      form={form}
      {...formItemLayout}
      className="details_form"
      onValuesChange={handleFormChange}
      onFieldsChange={handleFormChange}
    >
      <Title className="details_form_header" title="Asset details" subTitle="Product" />

      <Form.Item label="Kind" name="productKind" rules={isEditMode ? [{ required: true, message: 'Please select the product kind!' }] : []}>
        <Select disabled={!isEditMode}>
          {productKinds.map(name => (
            <Option key={name} value={name}>{t("businessEnums.productKind." + name, name)}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Category" name="productCategory">
        <Input disabled={!isEditMode} />
      </Form.Item>

      <Form.Item label="Quantity" name="quantity">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item label="Unit" name="unit">
        <Select disabled={!isEditMode} allowClear>
          {measurementUnits.map(name => (
            <Option key={name} value={name}>{t("businessEnums.measurementUnit." + name, name)}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Value (€)" name="value">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item label="Details" name="details">
        <Input disabled={!isEditMode} />
      </Form.Item>
    </Form>
  );
};

export default ProductForm;
